import classnames from 'classnames';
import {
  AccordionBlock as V3AccordionBlock,
  AccordionBlockProps,
} from '@stadionhq-v3/base-ui';
import { Plus } from '@components/icons';
import styles from './accordionBlock.module.scss';

const AccordionBlock = ({ ...props }: AccordionBlockProps) => {
  const classes = classnames([
    styles.accordionBlockTokens,
    styles.accordionBlock,
    styles[props.theme?.themeId || 'colourTheme1'],
  ]);

  return <V3AccordionBlock {...props} classNames={[classes]} icon={<Plus />} />;
};

export default AccordionBlock;
